export default {
    user: {
        displayNameMaxLen: 30,
        usernameMaxLen: 30,
        handleMaxLen: 20,
    },
};
